import React from 'react';
import Img from 'gatsby-image';
import SEO from '@interness/web-core/src/components/modules/SEO/SEO';
import Spacer from '@interness/web-core/src/components/structure/Spacer/Spacer';
import Wrapper from '@interness/web-core/src/components/structure/Wrapper/Wrapper';
import Heading from '@interness/web-core/src/components/text/Heading/Heading';
import CallToAction from '@interness/web-core/src/components/modules/CallToAction/CallToAction';
import HeaderImage from '@interness/web-core/src/components/media/HeaderImage/HeaderImage';
import Logo from '@interness/web-core/src/components/media/Logo/Logo';
import BrandsSubnavigation from '@interness/brands-addon/src/components/modules/BrandsSubnavigation/BrandsSubnavigation';
import { jsx as ___EmotionJSX } from "@emotion/react";
function PageLayout(props) {
  const {
    page,
    translations,
    seoTitle,
    showCallToAction,
    headerImage,
    showSubnavigation,
    showHeading
  } = props;
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(SEO, {
    title: seoTitle,
    description: translations.seo_description ? translations.seo_description : null,
    lang: translations.language
  }), headerImage && ___EmotionJSX(HeaderImage, null, ___EmotionJSX(Img, {
    fluid: headerImage,
    alt: translations.display_name,
    loading: "eager"
  })), showSubnavigation && ___EmotionJSX(BrandsSubnavigation, {
    type: props.type
  }), ___EmotionJSX(Wrapper, null, showHeading && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Spacer, null), ___EmotionJSX(Heading, {
    text: seoTitle
  }, page.logo ? ___EmotionJSX("div", {
    style: {
      maxHeight: '80px',
      maxWidth: '240px',
      margin: 'auto'
    }
  }, ___EmotionJSX(Logo, {
    title: seoTitle,
    svgWidth: "240px",
    svgHeight: "80px",
    logo: page.logo.localFile
  })) : ___EmotionJSX(React.Fragment, null, seoTitle)), ___EmotionJSX(Spacer, null)), props.children, showCallToAction && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Spacer, null), ___EmotionJSX("div", {
    style: {
      textAlign: 'center'
    }
  }, ___EmotionJSX(CallToAction, null))), ___EmotionJSX(Spacer, null)));
}
PageLayout.defaultProps = {
  submenu: [],
  showCallToAction: false,
  showHeading: true
};
export default PageLayout;